import {
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
  faMobileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import md5 from "blueimp-md5";
import React, { useEffect, useState } from "react";
import ToBack from "../components/ToBack";

const Recover = () => {
  const [data, setData] = useState({
    password1: "",
    password2: "",
    code: "",
    email: "",
    phone: "",
  });

  const [candidate, setCandidate] = useState({
    id: 0,
    uuid: 0,
  });

  const [count, setCount] = useState({
    countdown: 60,
    flag: true,
  });

  const [err, setErr] = useState({
    password1: false,
    password2: false,
    code: false,
    email: false,
    phone: false,
  });

  const [hide, setHide] = useState(true);

  const [hide1, setHide1] = useState(true);

  const [verifyType, setVerifyType] = useState("email"); // email or phone

  useEffect(() => {
    sessionStorage.removeItem("auth");
  }, []);

  const handleChange = (e) => {
    const { value, name } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRecover = async () => {
    const errData = {};

    if (verifyType === "email") {
      Object.getOwnPropertyNames(data).forEach((key) => {
        if (key !== "phone" && data[key].trim() === "") {
          errData[key] = "请填写内容";
        }
      });
    } else {
      Object.getOwnPropertyNames(data).forEach((key) => {
        if (key !== "email" && data[key].trim() === "") {
          errData[key] = "请填写内容";
        }
      });
    }

    if (Object.getOwnPropertyNames(errData).length !== 0) {
      setErr(errData);
      return;
    }

    if (data.password1 !== data.password2) {
      setErr(() => ({
        password1: "请确认密码",
        password2: "请确认密码",
      }));
      return;
    }

    if (verifyType === "email") {
      fetch(
        `/crate-api/staging?option=filterBy-refId-tag-detail&refId=${candidate.id}&tag=验证码&detail=${JSON.stringify({ category: "个人用户" })}`,
      )
        .then((response) => response.json())
        .then((res) => {
          res.forEach((item) => {
            if (data.code === item.detail.code) {
              fetch(`/gin-api/candidate/${candidate.uuid}/${candidate.id}?option=resetPassword`, {
                method: "PATCH",
                headers: { "content-type": "application/json" },
                body: JSON.stringify({
                  password: md5(data.password1),
                  code: data.code,
                  email: data.email,
                  category: "个人用户",
                }),
              }).then((response) => {
                if (response.status > 400) {
                  window.alert("操作失败，请稍后重试!");
                  return;
                }
                window.alert("操作成功");
                location.href = "#登录";
              });
            } else {
              console.log("验证码错误");
            }
          });
        });
    } else {
      // 手机验证码验证逻辑
      fetch("/gin-api/candidate/reset-password-by-phone-code", {
        method: "PATCH",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          phone: data.phone,
          code: data.code,
          password: md5(data.password1),
        }),
      })
        .then((response) => {
          if (response.ok) {
            window.alert("密码重置成功，请重新登录");
            location.href = "#登录";
          } else {
            throw new Error("验证码错误或操作失败");
          }
        })
        .catch((err) => alert(err));
    }
  };

  const handleCode = () => {
    const reg = /^[a-zA-Z0-9]+([._-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    if (reg.test(data.email) === false) {
      alert("请检查邮箱格式是否输入正确");
      return;
    }
    fetch(`/gin-api/candidate?option=filterBy-email&email=${data.email}`)
      .then((response) => response.json())
      .then((data) => {
        setCandidate({
          id: data.id,
          uuid: data.uuid,
        });
        if (data.id !== "") {
          const code = setInterval(() => {
            if (count.countdown === 1) {
              clearInterval(code);
              setCount({
                flag: true,
                countdown: 60,
              });
            } else {
              setCount({
                flag: false,
                countdown: (count.countdown -= 1),
              });
            }
          }, 1000);
          fetch("/crate-api/email/actions/send-mail-2-reset-password", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
              refId: data.id,
              email: data.email,
              detail: { category: "个人用户" },
            }),
          }).then((response) => {
            if (response.status === 200) {
              alert("验证码已经到邮箱，请注意查收！");
            } else {
              alert("验证码发送失败，请您稍后重试");
            }
          });
        } else {
          window.alert("您输入的邮箱还没有注册本平台,请您重新输入！");
        }
      });
  };

  const checkEmail = () => {
    if (data.email === "") {
      return true;
    }
  };

  const checkPhone = () => {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
    return reg.test(data.phone);
  };

  const handleSendSmsCode = async () => {
    if (!checkPhone()) {
      alert("请输入正确的手机号");
      return;
    }

    try {
      const response = await fetch(`/gin-api/candidate?option=by-phone&phone=${data.phone}`);
      const user = await response.json();
      if (!user) {
        alert("该手机号码未注册");
        throw new Error("该手机号码未注册");
      }
    } catch (err) {
      console.error(err);
      return;
    }

    fetch("/gin-api/ephemeral/phone", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        phone: data.phone,
        purpose: "重置密码",
      }),
    })
      .then((response) => {
        if (response.ok) {
          setCount({
            flag: false,
            countdown: 60,
          });
          const timer = setInterval(() => {
            setCount((prev) => {
              if (prev.countdown <= 1) {
                clearInterval(timer);
                return {
                  flag: true,
                  countdown: 60,
                };
              }
              return {
                flag: false,
                countdown: prev.countdown - 1,
              };
            });
          }, 1000);
          alert("验证码已发送到您的手机");
        } else {
          throw new Error("发送失败，请稍后重试");
        }
      })
      .catch((err) => alert(err));
  };

  const onHide = (e) => {
    setHide(e);
  };

  const onHide1 = (e) => {
    setHide1(e);
  };

  return (
    <>
      <div className="container-fluid background-login">
        <ToBack />
        <div className="row mt-3 bg-transparent text-white">
          <div className="col">
            <h4 className="text-center ">密码重置</h4>
          </div>
        </div>

        <div className="row bg-transparent text-dark">
          <div className="col">
            <div className="card border-0 bg-transparent text-dark">
              <div className="card-body card-p">
                <div className="mb-3 text-center">
                  <button
                    className={`btn btn-sm mr-2 font-weight-bold ${verifyType === "email" ? "bg-warning text-dark border border-dark shadow" : "bg-white text-primary border border-primary shadow"}`}
                    onClick={() => setVerifyType("email")}
                  >
                    邮箱验证码重置
                  </button>
                  <button
                    className={`btn btn-sm font-weight-bold ${verifyType === "phone" ? "bg-warning text-dark border border-dark shadow" : "bg-white text-primary border border-primary shadow"}`}
                    onClick={() => setVerifyType("phone")}
                  >
                    手机验证码重置
                  </button>
                </div>
                <form>
                  {verifyType === "email" ? (
                    <>
                      {err.email && <small className="form-text text-danger">{err.email}</small>}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <div className="input-group-prepend ">
                          <span className="input-group-text bg-transparent text-white border-0">
                            <FontAwesomeIcon icon={faEnvelope} fixedWidth />
                          </span>
                        </div>
                        <input
                          type="text"
                          name="email"
                          value={data.email}
                          className="form-control col border-0 bg-transparent text-white input-placeholder input-f"
                          placeholder="电子邮箱"
                          onChange={handleChange}
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      {err.phone && <small className="form-text text-danger">{err.phone}</small>}
                      <div className="input-group row mb-3 input-group-lg input-control">
                        <div className="input-group-prepend">
                          <span className="input-group-text bg-transparent text-white border-0">
                            <FontAwesomeIcon icon={faMobileAlt} fixedWidth />
                          </span>
                        </div>
                        <input
                          type="text"
                          name="phone"
                          value={data.phone}
                          className="form-control col border-0 bg-transparent text-white input-placeholder input-f"
                          placeholder="手机号码"
                          onChange={handleChange}
                        />
                      </div>
                    </>
                  )}
                  {err.code && <small className="form-text text-danger">{err.code}</small>}
                  <div className="input-group row mb-3 input-group-lg input-control">
                    <input
                      type="text"
                      name="code"
                      value={data.code}
                      className="form-control col border-0  bg-transparent text-white input-placeholder input-f"
                      placeholder="验证码"
                      onChange={handleChange}
                    />
                    <div className="input-group-append">
                      {verifyType === "email" ? (
                        count.flag ? (
                          <button
                            type="button"
                            className="col btn btn-primary btn-sm font-weight-bold text-white border border-primary"
                            disabled={checkEmail()}
                            onClick={handleCode}
                            style={{ fontSize: 14 }}
                          >
                            发送验证码
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="col btn btn-primary btn-sm font-weight-bold text-white border border-primary"
                            disabled="disabled"
                            style={{ fontSize: 14 }}
                          >
                            已发送{count.countdown}s
                          </button>
                        )
                      ) : count.flag ? (
                        <button
                          type="button"
                          className="col btn btn-primary btn-sm font-weight-bold text-white border border-primary"
                          disabled={!checkPhone()}
                          onClick={handleSendSmsCode}
                          style={{ fontSize: 14 }}
                        >
                          发送验证码
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="col btn btn-primary btn-sm font-weight-bold text-white border border-primary"
                          disabled="disabled"
                          style={{ fontSize: 14 }}
                        >
                          已发送{count.countdown}s
                        </button>
                      )}
                    </div>
                  </div>
                  {err.password1 && (
                    <small className="form-text text-danger">{err.password1}</small>
                  )}
                  <div className="input-group row mb-3 input-group-lg input-control">
                    <div className="input-group-prepend ">
                      <span className="input-group-text bg-transparent text-white  border-0">
                        <FontAwesomeIcon icon={faLock} fixedWidth />
                      </span>
                    </div>
                    <input
                      type={hide ? "password" : "text"}
                      name="password1"
                      value={data.password1}
                      autoComplete="off"
                      className="form-control col border-0 bg-transparent text-white input-placeholder input-f"
                      placeholder="密码"
                      onChange={handleChange}
                    />
                    {hide ? (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide(false)}
                        >
                          <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                        </span>
                      </div>
                    ) : (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide(true)}
                        >
                          <FontAwesomeIcon icon={faEye} fixedWidth />
                        </span>
                      </div>
                    )}
                  </div>
                  {err.password2 && (
                    <small className="form-text text-danger">{err.password2}</small>
                  )}
                  <div className="input-group row mb-3 input-group-lg input-control">
                    <div className="input-group-prepend ">
                      <span className="input-group-text bg-transparent text-white  border-0">
                        <FontAwesomeIcon icon={faLock} fixedWidth />
                      </span>
                    </div>
                    <input
                      type={hide1 ? "password" : "text"}
                      name="password2"
                      value={data.password2}
                      className="form-control col border-0  bg-transparent text-white input-placeholder input-f"
                      autoComplete="off"
                      placeholder="确认密码"
                      onChange={handleChange}
                    />
                    {hide1 ? (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide1(false)}
                        >
                          <FontAwesomeIcon icon={faEyeSlash} fixedWidth />
                        </span>
                      </div>
                    ) : (
                      <div className="input-group-append">
                        <span
                          className="input-group-text bg-transparent text-white border-0"
                          onClick={() => onHide1(true)}
                        >
                          <FontAwesomeIcon icon={faEye} fixedWidth />
                        </span>
                      </div>
                    )}
                  </div>
                </form>
              </div>

              <div className="form-group row">
                <button
                  type="button"
                  style={{ width: "80%", fontSize: "16px" }}
                  className="btn btn-block mx-auto rounded-pill button-background text-white font-weight-bold border border-light"
                  onClick={handleRecover}
                >
                  确&nbsp;定
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Recover;
